import Box from '@mui/system/Box';
import { useStacklineTheme } from '@stackline/ui';
import React from 'react';
import { CurrencyInput, CurrencyInputProps } from 'src/components/BeaconV2Components/common/StyledInput/CurrencyInput';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

interface RetailPriceFilterSectionProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>, type: 'min' | 'max') => void;
  retailPriceRange: { min?: string; max?: string }[];
}

const RetailPriceFilterSection: React.FC<RetailPriceFilterSectionProps> = ({ onChange, retailPriceRange }) => {
  const theme = useStacklineTheme();

  const inputStyles: CurrencyInputProps['sx'] = {
    fontSize: '12px',
    width: '72px',
    letterSpacing: '0.8px',
    height: '32px',
    '::placeholder': {
      color: '#BEC7D3'
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" marginTop="0px" gap="16px">
      <Flex marginTop={theme.spacing.mdl}>
        <Text variant="subtitle1">Price Range</Text>
      </Flex>
      <Box display="flex" alignItems="center" gap="12px">
        <Flex position="relative" flexDirection="column">
          <CurrencyInput
            onChange={(e) => onChange(e, 'min')}
            sx={inputStyles}
            value={retailPriceRange[0].min ?? ''}
            placeholder="min"
          />
        </Flex>
        <Text variant="subtitle2">to</Text>
        <Flex position="relative" flexDirection="column">
          <CurrencyInput
            onChange={(e) => onChange(e, 'max')}
            sx={inputStyles}
            value={retailPriceRange[1].max ?? ''}
            placeholder="max"
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default RetailPriceFilterSection;
